/**
 * Deterministic hashing and pseudo-randomness — the two primitives every procedural subsystem needs.
 *
 * `util/` rather than beside a caller because they are pure integer arithmetic with no notion of
 * voxels, terrain or stamps, and because a second copy of an LCG is a second WORLD: these constants
 * decide where every tree, rock and building stands, so they belong somewhere a new caller finds them
 * rather than re-derives them.
 *
 * NOTE for anyone consolidating further: `StampPointGenerator.seededRandom` looks like `makeRng` and is
 * NOT the same generator — it multiplies in floating point where this uses `Math.imul`, so the two
 * diverge once the product passes 2^53. Folding it in here would move every scattered position in the
 * world; it is left alone on purpose.
 */
/** Deterministic 2D integer hash → uint32 seed (per-building / per-cell decoration RNG). */
export function hashInt2(a, b) {
    let h = 2166136261 >>> 0;
    h = Math.imul(h ^ (a | 0), 16777619);
    h = Math.imul(h ^ (b | 0), 16777619);
    h ^= h >>> 13;
    h = Math.imul(h, 16777619);
    return h >>> 0;
}
/** Small seeded LCG returning values in [0, 1). */
export function makeRng(seed) {
    let state = (seed >>> 0) || 1;
    return () => {
        state = (Math.imul(state, 1103515245) + 12345) >>> 0;
        return (state & 0x7fffffff) / 0x7fffffff;
    };
}
//# sourceMappingURL=rng.js.map